import { render, staticRenderFns } from "./VideoCourse.vue?vue&type=template&id=d204224c&scoped=true"
import script from "./VideoCourse.vue?vue&type=script&lang=js"
export * from "./VideoCourse.vue?vue&type=script&lang=js"
import style0 from "./VideoCourse.vue?vue&type=style&index=0&id=d204224c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d204224c",
  null
  
)

export default component.exports